import { render } from "./SelectProvider.vue?vue&type=template&id=1828d136&scoped=true&lang=pug"
import script from "./SelectProvider.vue?vue&type=script&lang=js"
export * from "./SelectProvider.vue?vue&type=script&lang=js"

import "./SelectProvider.vue?vue&type=style&index=0&id=1828d136&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1828d136"]])

export default __exports__